services.service('CountryService', [
    '$q', '$http', 'config', 'constants', 'ErrorService', 'Utils', 'Storage', 'BaseCollection',
    function ($q, $http, config, Const, ErrorService, Utils, Storage, BaseCollection) {
        var self = this,
            countries = new BaseCollection();

        this.init = function () {
            var _countries = Storage.get('countries')
                .map(function (country) {
                    if (!country.customFields) {
                        country.customFields = [];
                    }
                    return country;
                });
            countries.fill(_countries);
            log('Initializing country service');
        };

        this.get = function () {
            return countries.getAll();
        };

        this.getCitizenships = function () {
            const citizenships = countries.findBy({}, function (country) {
                return country.citizenship.length > 0
            });
            return _.chain(citizenships).uniqBy('citizenship').orderBy('citizenship').value();
        };

        this.getAllowedCountries = function () {
            return countries.find({allowRegistration: 1});
        };

        this.getCountryStates = function (country) {
            return country.states.length > 0
                ? _.orderBy(country.states, ['stateName'])
                : []
        };

        this.getAllowedUserCountries = function (code) {
            return countries.getAll()
                .map(function (country) {
                    if (country.code === code) {
                        country.allowRegistration = 1;
                    }
                    return country;
                })
                .filter(function (country) {
                    return country.allowRegistration === 1
                });
        };

        this.countries = countries;

        return this;
    }
]);
